import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type RequestStatus } from '@/microfrontends/filters/shared/types/RequestStatus';
import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';

import { SEARCH_META_DEFAULT } from '../../constants/searchMeta';
import { updateSearchMeta } from '../../thunks/searchMeta';

export interface ISearchMetaState {
  status: RequestStatus;
  data: ISearchMeta;
}

const searchMetaInitialState: ISearchMetaState = {
  status: 'initial',
  data: SEARCH_META_DEFAULT,
};

export const searchMetaSlice = createSlice({
  initialState: { ...searchMetaInitialState },
  name: 'searchMeta',
  reducers: {
    set(state, action: PayloadAction<ISearchMeta>) {
      state.data = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updateSearchMeta.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateSearchMeta.fulfilled, (state, action) => {
        state.status = 'succeed';
        state.data = action.payload;
      })
      .addCase(updateSearchMeta.rejected, (state, action) => {
        if (action.payload === 'canceled') {
          return;
        }

        state.status = 'failed';
      });
  },
});

export const { reducer: searchMetaReducer, actions: searchMetaActions } = searchMetaSlice;
